import { render, staticRenderFns } from "./r-global-config-dropdown.vue?vue&type=template&id=dbbe39aa"
import script from "./r-global-config-dropdown.vue?vue&type=script&lang=js"
export * from "./r-global-config-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbbe39aa')) {
      api.createRecord('dbbe39aa', component.options)
    } else {
      api.reload('dbbe39aa', component.options)
    }
    module.hot.accept("./r-global-config-dropdown.vue?vue&type=template&id=dbbe39aa", function () {
      api.rerender('dbbe39aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/global-config/r-global-config-dropdown.vue"
export default component.exports